module.exports = __webpack_public_path__ + "static/img/sggs_img_4.8c25a242.png";